import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useGetAllAccounts1Query } from "../../../../store/api/itemtaxapi";
import SearchableDropdown from "../../../../Core/Fields/Floating/SearchableDropdown";
import { skipToken } from "@reduxjs/toolkit/query";
const Table = ({ selectedTaxAccounts, compname }) => {
  const { value: rowsRaw = [], setValue = () => {} } = selectedTaxAccounts || {};
  const rows = Array.isArray(rowsRaw) ? rowsRaw : [];

  const tableRef = useRef();

  // Pagination
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const dropdownRefAccount = useRef(null);
  // States
  const [selectedRows, setSelectedRows] = useState([]);
   const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
    const [showDropdown, setShowDropdown] = useState({ rowIndex: null, field: null });
  
  const [accountOptions, setAccountOptions] = useState([]);
 const [offsetType, setOffsetType] = useState(0);
  const [offsetAccount, setOffsetAccount] = useState(0);
  const [searchType, setSearchType] = useState("");
  const [searchAccount, setSearchAccount] = useState("");
  const [hasMoreType, setHasMoreType] = useState(true);
  const [hasMoreAccount, setHasMoreAccount] = useState(true);
  // ✅ Track company change → clear tax in all rows if company removed/changed
  const [previousCompany, setPreviousCompany] = useState("");
 useEffect(() => {
  // If company changed or removed, clear account_head in all rows
  if (previousCompany && previousCompany !== compname) {
    const updatedRows = rows.map((r) => ({ ...r, account_head: "" }));
    setValue(updatedRows);
  } else if (!compname) {
    const updatedRows = rows.map((r) => ({ ...r, account_head: "" }));
    setValue(updatedRows);
  }

  setPreviousCompany(compname);
}, [compname]);


  // ✅ API: Only trigger when company selected
const { data } = useGetAllAccounts1Query(
  compname?.trim() ? { company: compname.trim() } : skipToken
);

// console.log('hjh:',data);
  // ✅ Format account head (tax) dropdown options
  useEffect(() => {
    if (!compname) {
      setAccountOptions([]);
      return;
    }

    if (data?.message && Array.isArray(data.message)) {
      const formatted = data.message.map((item) => ({
        name: item.value,
      }));
      setAccountOptions(formatted);
    } else {
      setAccountOptions([]);
    }
  }, [data, compname]);

  // ✅ Add default row
  const createNewRow = () => ({
    tax_type: "",
    tax_rate: "",
  });

  useEffect(() => {
    if (!rowsRaw?.length) {
      setValue([createNewRow()]);
    }
  }, []);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

  // ✅ Update row
  const updateRow = (index, field, value) => {
    const cloned = JSON.parse(JSON.stringify(rows || []));
    while (cloned.length <= index) cloned.push(createNewRow());
    cloned[index][field] = value;
    setValue(cloned);
  };

  // ✅ Add/Delete Row
  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setValue(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setValue(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) setCurrentPage(lastPage);
  };
 // Column Resizing
  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th") || [];
    cols.forEach((col) => {
      if (col.querySelector(".resizer")) return;
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);
  // ✅ Table Rendering
  return (
    <div className="table-container">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Tax Type",
              "Tax Rate",
              <GetIcon iconName="PiSlidersHorizontalBold" size={12} />,
            ].map((title, i) => (
              <th
                key={i}
                style={{
                  width: title === "Action" ? "50px" : "150px",
                  textAlign: "center",
                }}
              >
                {title === "Action" ? (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isAllSelected}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedRows(rows.map((_, index) => index));
                      } else {
                        setSelectedRows([]);
                      }
                    }}
                    style={{
                      backgroundColor: isAllSelected ? "#270b79" : "",
                      borderColor: isAllSelected ? "#270b79" : "",
                    }}
                  />
                ) : (
                  title
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, idx) => {
            const globalIndex = indexOfFirstRow + idx;

            return (
              <tr key={globalIndex}>
                {/* ✅ Checkbox */}
                <td style={{ width: "4%", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedRows.includes(globalIndex)}
                    onChange={() =>
                      setSelectedRows((prev) =>
                        prev.includes(globalIndex)
                          ? prev.filter((i) => i !== globalIndex)
                          : [...prev, globalIndex]
                      )
                    }
                    style={{
                      backgroundColor: selectedRows.includes(globalIndex)
                        ? "#270b79"
                        : "",
                      borderColor: selectedRows.includes(globalIndex)
                        ? "#270b79"
                        : "",
                      marginTop: "8px",
                    }}
                  />
                </td>

                {/* ✅ Serial Number */}
                <td style={{ width: "4%", textAlign: "center" }}>
                  {globalIndex + 1}
                </td>

                {/* ✅ Tax Dropdown */}
                <td className="p-0">
                  <SearchableDropdown
  globalIndex={globalIndex}
  field="tax_type"
  value={row?.tax_type || ""}
  onChange={(val) => updateRow(globalIndex, "tax_type", val)}
  onSearch={(text) => setSearchAccount(text)}
  dropdownData={accountOptions}
  placeholder={
    !compname?.trim()
      ? "Select Company First"
      : "Select Tax Type"
  }
  focusedCell={focusedCell}
  setFocusedCell={setFocusedCell}
  showDropdown={showDropdown}
  setShowDropdown={setShowDropdown}
  dropdownRef={dropdownRefAccount}
  setOffset={setOffsetAccount}
  offset={offsetAccount}
  search_input={searchAccount}
  hasMore={hasMoreAccount}
  getData={() => setAccountOptions(accountOptions)}
  disabled={!compname?.trim()} // ✅ prevent selecting before company
/>
                 
                </td>

                {/* ✅ Tax Rate Input */}
                <td className="p-0">
                  <input
                    type="number"
                    placeholder="Enter Tax Rate"
                    className="form-control tableinput noborder"
                    value={row.tax_rate || ""}
                    style={{ fontSize: "0.8rem", textAlign: "center" }}
                    onChange={(e) =>
                      updateRow(globalIndex, "tax_rate", e.target.value)
                    }
                    // disabled={!compname}
                  />
                </td>

                {/* ✅ Action icon */}
                <td
                  style={{
                    position: "relative",
                    width: "40px",
                  }}
                >
                  <img
                    src="/Maskgroup.png"
                    alt="edit"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "12px",
                      height: "12px",
                      pointerEvents: "none",
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* ✅ Bottom Bar */}
      <div className="d-flex pb-2 justify-content-between align-items-center mt-3">
        <div className="d-flex" style={{ gap: "4px" }}>
          {selectedRows.length > 0 ? (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          ) : (
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{
                backgroundColor: "#F6D593",
                padding: "1px",
                display: "flex",
              }}
            >
              Add Row
            </Button>
          )}
        </div>

        {/* ✅ Pagination */}
        {rows.length > 10 && (
          <div className="d-flex align-items-center centerpagination" style={{ gap: "5px" }}>
            <Pagination
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pageSize={rowsPerPage}
              totalrecords={rows.length}
            />
          </div>
        )}

        {rows.length > 10 && (
          <div className="d-flex">
            <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
              Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of{" "}
              {rows.length} entries
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Table;
